export const filterByExtensionIds = (allowedExtensionsIds: string[]) => {
  const allowedIdsSet = new Set(allowedExtensionsIds);

  return (extensionsIds: string[]): string[] =>
    extensionsIds.filter((id) => allowedIdsSet.has(id));
};
